import * as React from 'react';
import { SingleValueComponent } from '../common';
import { InputControlContext } from '../common/input-control-context/input-control-context';
import { DebounceInput } from '../common/debounce-input';

/**
 * Simple component for text input.
 *
 * > It supports common InputControlContext component.
 */
export interface TextboxProps extends SingleValueComponent<string> {
  /**
   * Define max length of content text. Default is unlimited.
   */
  maxLength?: number;
  
}

export class Textbox extends React.Component<TextboxProps, any> {

  private onBlur = (e: React.FormEvent<HTMLInputElement>) => {
    const currentTarget = e.currentTarget;    
    this.props.onBlur && this.props.onBlur(currentTarget.value);
  };

  public render() {

    const {
      componentId,
      maxLength,
      readOnly,
      value,
      placeholder
    } = this.props;

    return (
      <InputControlContext
        componentId={componentId}
        className={this.props.className}
        label={this.props.label}
        info={this.props.info}
        infoLong={this.props.infoLong}
        validation={this.props.validation}
        readOnly={readOnly}
        >
        <div className="input-wrapper">
          <DebounceInput
            className="form-control"
            maxLength={maxLength}
            readOnly={readOnly}
            value={value}
            placeholder={!readOnly ? placeholder : undefined}
            onChange={this.props.onChange}            
            focus={this.props.focus} 
            onBlur={this.onBlur}/>
        </div>
      </InputControlContext>
    );
  }
}
